module.exports = __webpack_public_path__ + "img/security3.155e1d0b.png";